/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  account: "Account",
  accountDetails: "Account details",
  accountNotFound: "Account not found",
  accountNumber: "Account number",
  accountOwner: "Account owner",
  accounts: "Accounts",
  accountType: "Account type",
  amount: "Amount ({{currency}})",
  availableFunds: "Available funds",
  backToAllAccounts: "Back to all accounts",
  balance: "Balance",
  balanceAfter: "Balance after",
  balanceCurrency: "Balance ({{currency}})",
  closedLoopPayout: "Closed loop payout",
  completed: "Completed",
  connected: "Connected",
  connectMatching: "Connect Matching",
  credit: "Credit",
  debit: "Debit",
  failed: "Failed",
  givenAccountCouldNotBeFound: "Given account could not be found",
  iban: "IBAN",
  ignored: "Ignored",
  inPayout: "In payout",
  inReturn: "In return",
  noTransactions: "No transactions",
  openLoopPayout: "Open loop payout",
  payment: "Payment",
  pending: "Pending",
  processing: "Processing",
  recalled: "Recalled",
  reference: "Reference",
  refund: "Refund",
  rejected: "Rejected",
  retry: "Retry",
  return: "Return",
  returned: "Returned",
  returnedManually: "Returned manually",
  reversal: "Reversal",
  settlement: "Settlement",
  sortCode: "Sort code",
  swiftCodeBic: "Swift code (BIC)",
  transactionAmount: "Transaction amount",
  transactions: "Transactions",
  unknownType: "Unknown Type",
  viewDetails: "View details",
  volt: "Volt",
  waiting: "Waiting",
  withdrawal: "Withdrawal",
  youDontHaveAnyTransactionsYet: "You don't have any transactions yet.",
};
